import { render, staticRenderFns } from "./skillList.vue?vue&type=template&id=204cc934&scoped=true"
import script from "./skillList.vue?vue&type=script&lang=js"
export * from "./skillList.vue?vue&type=script&lang=js"
import style0 from "./skillList.vue?vue&type=style&index=0&id=204cc934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204cc934",
  null
  
)

export default component.exports